<section class="titulo">
    <p>
        <br><br>
    </p>
    <div class="titleImagen">
        <p style="line-height: 100%;" class="fontMS700 colorPrincipal font-45 mb-0">
            LA PRENSA EN LA INDEPENDENCIA
        </p>
        <p class="fontMS100 colorPrincipal font-45">(1805-1825)</p>
        <div id="sharePic">
            <a (click)="test.toggle()" mdbWavesEffect>
                <img width="200px" src="/assets/images/general/MP_BOTON_COMPARTIR.jpg">
            </a>
            <div mdbCollapse #test="bs-collapse">
                <div class="divShared">
                    &nbsp;
                    &nbsp;
                    <a target="_blank"
                        href="http://www.facebook.com/sharer.php?u=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio25/prensa-independecia">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_FB.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://api.whatsapp.com/send?text=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio25/prensa-independecia">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_INST.png">
                    </a>&nbsp;
                    <a target="_blank"
                        href="https://twitter.com/intent/tweet?text=MemoriaPeru&url=https://memoriaperu.bnp.gob.pe%2F%23%2Fmicrositio25/prensa-independecia">
                        <img width="25px" src="/assets/images/general/MP_BOTON_COMPARTIR_TW.png">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <img class="img_portada" src="/assets/images/micrositio/micrositio25/PRENSA-000.jpg">
</section>
<div class="fondoBlanco_Intro mt-1">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <p class="fontMS500 text-center font-24 mb-0">
                    LA INDEPENDENCIA PERUANA FUE UN PROCESO HISTÓRICO-SOCIAL 
                </p>
                <p class="fontMS500 text-center font-24">
                    COMPLEJO QUE PUEDE ESTUDIARSE DESDE MÚLTIPLES PUNTOS DE VISTA. 
                </p>
                <p class="fontMS100 text-justify font-24">
                    <br>
                    Es en este contexto del proceso emancipador peruano, de ideas, disputas políticas, sociales y
                    culturales, las publicaciones periódicas se convirtieron en herramienta de información,
                    de adoctrinamiento y propaganda. Un ejemplo claro es el discurso oficial en la prensa manifestada
                    en medios como La Minerva Peruana o La Gaceta del Gobierno de Lima. 
                    <br> <br>
                    Este periodismo nació bajo la influencia de la Constitución de Cádiz de 1812 (El Investigador),
                    y la prensa doctrinal que, entre otros aspectos, promovió debates en torno al nuevo gobierno 
                    (El Triunfo de la Nación o Los Andes Libres).
                </p>
                <p class="fontMS100 text-justify font-24">
                    <br>
                    El investigador Carlos Cornejo Quesada explica que: «El periodismo durante la lucha por la independencia
                    hasta los primeros años de la fundación del estado criollo no fue homogéneo en su ideología, por no decir
                    también en otros aspectos de su composición formal y de su vida. En efecto, antes y hasta un poco después
                    de la Independencia, el contenido del periodismo se orientó a definirse en dos tendencias generales
                    e importantes: el periodismo realista y el periodismo patriótico. Pero conforme los acontecimientos políticos
                    ganaban la efervescencia social y el debate nacional se hacía más intenso y agitado por establecer un gobierno
                    republicano o absolutista, se daba pase al periodismo doctrinal».
                </p>
            </div>
        </div>
    </div>
</div>
<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-38">
                            LA VOZ OFICIAL EN LA PRENSA
                        </p>
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS100 text-center colorPrincipal font-38">
                            PROPAGANDA Y PROHIBICIONES
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 mt-5">
                        <p class="fontMS500  font-24 p-0 col-sm-12 col-lg-7">
                            <br>
                            A PARTIR DE 1805, LA CORONA ESPAÑOLA IMPONE 
                            EN SUS TERRITORIOS COLONIALES DE ULTRAMAR 
                            UNA NUEVA LEY DE IMPRENTA PARA EVITAR LA 
                            CIRCULACIÓN DE IDEAS REVOLUCIONARIAS.
                        </p>
                    </div>
                </div>


                <div class="row">
                    <div class="col-sm-6 mt-5">
                        <img class="img-fluid pd-10" width="100%" 
                        src="/assets/images/micrositio/micrositio25/PRENSA-001.jpg">
                        
                        <p class="fontMS500 text-justify font-20 font-italic pd-10 text-gris" >
                            <br>
                        Pedro Díaz. Virrey Fernando de Abascal. Óleo sobre 
                        lienzo, 1807. Museo de arte de la Universidad 
                        Nacional Mayor de San Marcos. Fuente: ARCA.
                        <br><br>
                         </p>
                        <br>
                    </div>
                    <div class="col-sm-6 mt-5">
                        <p class="fontMS100 text-justify font-24">
                            En el Virreinato del Perú, se restringe la
                            impresión, venta y lectura de materiales
                            políticos o extranjeros. Mientras tanto,
                            el virrey Fernando de Abascal recurre a los
                            medios oficiales para defender la figura y
                            autoridad de Fernando VII como el verdadero
                            rey de España y las Américas. A través de publicaciones
                            como La Minerva Peruana, disimula los fracasos
                            de la metrópoli, critica a los opositores del rey
                            y busca deslegitimar a los insurgentes americanos.

                        </p>
                    </div>
                </div>

                <div class="row">

                    <div class="col-sm-12">
                        <div class="row " style="margin-bottom:5rem">
                            <div class="col-sm-1 libro mt-5"></div>
                            <div class="col-sm-5 libro mt-5">
                                <a href="https://hdl.handle.net/20.500.14428/72105" target="_blank" style="color: black;">
                                    <img width="100%" 
                                        src="/assets/images/micrositio/micrositio25/PRENSA-002.jpg">
                                    <div class="overlay">
                                        <p class="fontMS100 text-center">
                                            <span class="fontMS500">
                                                La Minerva Peruana 
                                                <br>
                                            </span>
                                            No. 39 (31 agosto 1808) al <br>
                                            No. 75 (31 diciembre 1808).  
                                        </p>
                                    </div>
                                </a>
                            </div>
                            <div class="col-sm-5 libro mt-5">
                                <a href="https://hdl.handle.net/20.500.14428/72425" target="_blank" style="color: black;">
                                    <img width="100%" 
                                        src="/assets/images/micrositio/micrositio25/PRENSA-003.jpg">
                                    <div class="overlay">
                                        <p class="fontMS100 text-center">
                                            <span class="fontMS500">
                                                Gaceta del Gobierno de Lima. 
                                                <br>
                                            </span>
                                            <span class="fontMS100Italic">
                                                No. 33 (27 mayo 1820).  
                                                <br>
                                            </span>
                                            
                                        </p>
                                    </div>
                                </a>
                            </div>
                            <div class="col-sm-1 libro mt-5"></div>
                        </div>
                        <hr style="margin-bottom: 5rem">
                        <div class="row mt-5" >
                            <div class="col-sm-12">
                                <img width="100%" 
                                        src="/assets/images/micrositio/micrositio25/PRENSA-004.jpg">
                                <p class="fontMS500Italic bottom_cel font-22 mb-0 text-gris">
                                    <br>
                                    Promulgación de la Constitución de Cádiz de 1812. Salvador Viniegra. Óleo sobre lienzo. 1912. <br>
                                    Fuente: Museo de las Cortes de Cádiz.
                                </p>
                              
                                    
                            </div>
                            <div class="c100">
                                <p class="fontMS100Italic text-gris">
                                    Promulgación de la Constitución de Cádiz de 1812. Salvador Viniegra. Óleo sobre lienzo. 1912. 
                                    Fuente: Museo de las Cortes de Cádiz.</p>   
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            DISPUTAS POR EL PODER
                        </p>
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS100 text-center colorPrincipal font-40">
                            (1810-1814)
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                <br><br>
                <div class="row mt-5">
                    <!--<div class="col-sm-5 libro">
                        <img class="img-fluid pd-10" width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-005.jpg">
                        <p class="fontMS100Italic" style="color:grey;"><br> Miguelina Acosta Cárdenas
                            (Yurimaguas, 1887-1933)
                            Fuente: Herederos de Miguelina Acosta</p>
                    </div> -->
                    <div class="col-sm-12 bottom_cel">
                        <p class="fontMS500 text-white text-center font-24 ">
                            ANTE LA INVASIÓN NAPOLEÓNICA, LAS CORTES DE CÁDIZ SURGEN PARA 
                            DEFENDER LA SOBERANÍA DE ESPAÑA. ESTA ASAMBLEA CONSTITUYENTE 
                            IMPULSA UNA SERIE DE REFORMAS LIBERALES, UNA DE LAS MÁS IMPORTANTES 
                            ES LA LIBERTAD DE IMPRENTA, DECRETADA EL 10 DE NOVIEMBRE DE 1810.
                        </p>
                    </div>
                    <div class="col-sm-12 c100">
                        <p class="fontMS500 text-white text-center font-24">
                            ANTE LA INVASIÓN NAPOLEÓNICA, LAS CORTES DE CÁDIZ SURGEN PARA 
                            DEFENDER LA SOBERANÍA DE ESPAÑA. ESTA ASAMBLEA CONSTITUYENTE 
                            IMPULSA UNA SERIE DE REFORMAS LIBERALES, UNA DE LAS MÁS IMPORTANTES 
                            ES LA LIBERTAD DE IMPRENTA, DECRETADA EL 10 DE NOVIEMBRE DE 1810.
                        </p>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify text-white font-24">
                            En este contexto, Gaspar Rico y Angulo funda uno de los primeros medios de oposición en el Perú: <span class="fontMS100Italic">El Peruano.</span>
                            <br><br>
                            Este periódico difunde noticias sobre las Cortes de Cádiz y busca estimular el debate público. 
                            Como réplica, el virrey funda  <span class="fontMS100Italic">El Verdadero Peruano </span>y lo proclama como el vocero oficial del constitucionalismo liberal.

                        </p>
                    </div>
                </div>
                <!--Carusel-->
                <div class="row mt-4" >
                    <div class="w-100 text-center ml-auto mr-auto" style="margin-top:5%">
                        <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
                            <div ngxSlickItem *ngFor="let slide of slides" class="slide p-2">
                                <div class="divLibros text-center w-100">
                                    <a style="color: inherit;" href="{{slide.id}}" target="_blank">
                                        <p class="text-center">
                                            <img src="{{ slide.img }}" width="100%">
                                        </p>
                                        <div class="divNombresLibros">
                                            <p class="text-center">
                                                <span class="fontMS500">{{slide.autor}}</span><br>
                                                <span class="fontMS100">{{slide.anuNacimiento}}</span><br>
                                                <span class="fontMS100">{{slide.anno}}</span>
                                            </p>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </ngx-slick-carousel>
                    </div>

                   <!-- <div class="col-sm-4 libro">
                        <a [routerLink]="['/ficha/LIB-4117']" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio20/MUJER-006.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Miguelina Acosta Cárdenas. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Reformas necesarias del Código civil común peruano tendientes 
                                        a hacer efectiva la igualdad civil y jurídica del hombre y la mujer.  
                                        <br>
                                    </span>
                                    Imprenta Peruana, 1920. 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-5 bottom_cel" style="margin-top:18%;">
                        <div class="pi-10">
                            <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                            <a [routerLink]="['/visor/REV-197']" target="_blank" style="color: black; text-decoration: none;">
                                <p class="fontMS500 text-white font-24" style="margin:0%;">
                                    <span class="fontMS500Italic text-white">La Crítica,</span> Año 1, no. 15,<br>
                                    16 de diciembre de 1917.
                                </p>
                            </a>
                            <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                            <a [routerLink]="['/visor/REV-195']" target="_blank" style="color: black; text-decoration: none;">
                                <p class="fontMS500 text-white font-24" style="margin:0%;">
                                    <span class="fontMS500Italic text-white">La Crítica,</span> Año 1, no. 22,<br>
                                    3 de febrero de 1918.
                                </p>
                            </a>
                            <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                            <a [routerLink]="['/visor/REV-196']" target="_blank" style="color: black; text-decoration: none;">
                                <p class="fontMS500 text-white font-24" style="margin:0%;">
                                    <span class="fontMS500Italic text-white">La Crítica,</span> Año 2, no. 97,<br>
                                    1 de agosto de 1919.
                                </p>
                            </a>
                            <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        </div>
                    </div>
                    <div class="col-sm-5 c100" style="margin-top:18%;">
                        <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        <a [routerLink]="['/visor/REV-197']" target="_blank" style="color: black; text-decoration: none;">
                            <p class="fontMS500 text-white font-24" style="margin:0%;">
                                <span class="fontMS500Italic text-white">La Crítica,</span> Año 1, no. 15,<br>
                                16 de diciembre de 1917.
                            </p>
                        </a>
                        <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        <a [routerLink]="['/visor/REV-195']" target="_blank" style="color: black; text-decoration: none;">
                            <p class="fontMS500 text-white font-24" style="margin:0%;">
                                <span class="fontMS500Italic text-white">La Crítica,</span> Año 1, no. 22,<br>
                                3 de febrero de 1918.
                            </p>
                        </a>
                        <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        <a [routerLink]="['/visor/REV-196']" target="_blank" style="color: black; text-decoration: none;">
                            <p class="fontMS500 text-white font-24" style="margin:0%;">
                                <span class="fontMS500Italic text-white">La Crítica,</span> Año 2, no. 97,<br>
                                1 de agosto de 1919.
                            </p>
                        </a>
                        <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                    </div>
                    <div class="col-sm-3"></div>-->
                </div>
            </div>
        </div>
    </div>
</div>


<div class="fondoBlanco_Img2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            DEBATES EN TORNO <br>
                            AL NUEVO GOBIERNO
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                <div class="row" style="margin-top: 8rem">
                    <div class="col"></div>
                    <div class="col-sm-5">
                        <img class="img-fluid pd-10" width="100%" 
                        src="/assets/images/micrositio/micrositio25/PRENSA-010.jpg">
                        <p class="fontMS500Italic bottom_cel font-18 pd-10 text-gris">
                            <br>
                            Alberto Tauro, ed. Periódicos: El Pacificador -- El <br>
                            Triunfo de la Nación -- El Americano -- Los Andes <br>
                            Libres -- El Sol del Perú. Lima: Comisión Nacional <br>
                            del Sesquicentenario de la Independencia del Perú, <br>
                            [1972].<br>
                            000054765
                        </p>
                        
                    </div>
                    <div class="col-sm-5">
                        <p class="fontMS500 font-24">
                            REACCIONES A LA PROCLAMA DE 
                            INDEPENDENCIA. <span class="fontMS500Italic">EL TRIUNFO DE LA 
                            NACIÓN </span>RECHAZAR LA 
                            INDEPENDENCIA, UNA MONARQUÍA 
                            AMERICANA, MIRAR QUÉ ESTÁ 
                            PASANDO EN OTROS PAÍSES 
                            AMERICANOS.
                        </p>
                        <br>
                        <p class="fontMS100 font-22 text-justify" style="color:gray">
                            Sociedad patriótica, promovida por José de San 
                            Martín y Bernardo Monteagudo, quienes 
                            deseaban instalar una monarquía americana. Se 
                            convierte en un espacio de debate donde se 
                            desarrollan las ideas republicanas que servirán 
                            de base para la primera constitución.
                        </p>

                        <div class="col-sm-12 bottom_cel" style="margin-top:12%;">
                            <div class="">
                                <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                                <a href="http://hdl.handle.net/20.500.14428/79869"
                                 target="_blank" style="color: black; text-decoration: none;">
                                    <p class="fontMS100  font-22" style="margin:0%;">
                                        <span class="fontMS500">El Triunfo de la Nación.</span> Prospecto, y No. 1 <br>
                                        (13 de febrero de 1821) al No. 40 (29 de junio de 1821).
                                    </p>
                                </a>
                                <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                                <a href="https://hdl.handle.net/20.500.14428/78037"
                                 target="_blank" style="color: black; text-decoration: none;">
                                    <p class="fontMS100  font-22" style="margin:0%;">
                                        <span class="fontMS500">El Pacificador del Perú.</span> Prospecto, y No. 1 <br>
                                        (Huaura, 10 de abril de 1821) al No. 13 <br>
                                        (Lima, 1 de setiembre de 1821).
                                    </p>
                                </a>
                                <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                                <a href="http://hdl.handle.net/20.500.14428/79869"
                                target="_blank" style="color: black; text-decoration: none;">
                                    <p class="fontMS100  font-22" style="margin:0%;">
                                        <span class="fontMS500">El Americano.</span> No. 1 (10 de julio de 1821) <br>
                                        al No. 3 (14 de julio de 1821).
                                    </p>
                                </a>
                                <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                                <a href="http://hdl.handle.net/20.500.14428/79869"
                                 target="_blank" style="color: black; text-decoration: none;">
                                    <p class="fontMS100  font-22" style="margin:0%;">
                                        <span class="fontMS500">Los Andes Libres</span> No. 1 (24 de julio de 1821) <br>
                                        al No. 15 (24 de noviembre de 1821), y No. 19 
                                        (6 de diciembre de 1821).   
                                    </p>
                                </a><img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                                <a href="http://hdl.handle.net/20.500.14428/79869"
                                 target="_blank" style="color: black; text-decoration: none;">
                                    <p class="fontMS100  font-22" style="margin:0%;">
                                        <span class="fontMS500">El Sol del Perú</span> No. 1 (14 de marzo de 1822) <br>
                                        al No. 10 (27 de junio de 1822).
                                    </p>
                                </a>
                                <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                            </div>
                        </div>
                        <div class="col-sm-12 c100" style="margin-top:18%;">
                            <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                                <a href="http://hdl.handle.net/20.500.14428/79869"
                                 target="_blank" style="color: black; text-decoration: none;">
                                    <p class="fontMS100  font-22" style="margin:0%;">
                                        <span class="fontMS500">El Triunfo de la Nación.</span> Prospecto, y No. 1 <br>
                                        (13 de febrero de 1821) al No. 40 (29 de junio de 1821).
                                    </p>
                                </a>
                                <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                                <a href="https://repombd.bnp.gob.pe/bnp/recursos/biblioteca1/HTML/Sesquicentenario/periodicos-el-pacificador-el-triunfo-de-la-nacion-el%20americano-los-andes-libres-el-sol-del-peru-547653/208/"
                                 target="_blank" style="color: black; text-decoration: none;">
                                    <p class="fontMS100  font-22" style="margin:0%;">
                                        <span class="fontMS500">El Pacificador del Perú.</span> Prospecto, y No. 1 <br>
                                        (Huaura, 10 de abril de 1821) al No. 13 <br>
                                        (Lima, 1 de setiembre de 1821).
                                    </p>
                                </a>
                                <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                                <a href="http://hdl.handle.net/20.500.14428/79869"
                                target="_blank" style="color: black; text-decoration: none;">
                                    <p class="fontMS100  font-22" style="margin:0%;">
                                        <span class="fontMS500">El Americano.</span> No. 1 (10 de julio de 1821) <br>
                                        al No. 3 (14 de julio de 1821).
                                    </p>
                                </a>
                                <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                                <a href="http://hdl.handle.net/20.500.14428/79869"
                                 target="_blank" style="color: black; text-decoration: none;">
                                    <p class="fontMS100  font-22" style="margin:0%;">
                                        <span class="fontMS500">Los Andes Libres</span> No. 1 (24 de julio de 1821) <br>
                                        al No. 15 (24 de noviembre de 1821), y No. 19 
                                        (6 de diciembre de 1821).   
                                    </p>
                                </a><img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                                <a href="http://hdl.handle.net/20.500.14428/79869"
                                 target="_blank" style="color: black; text-decoration: none;">
                                    <p class="fontMS100  font-22" style="margin:0%;">
                                        <span class="fontMS500">El Sol del Perú</span> No. 1 (14 de marzo de 1822) <br>
                                        al No. 10 (27 de junio de 1822).
                                    </p>
                                </a>
                                <img width="100%" src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA2.jpg">
                        </div>
                    </div>
                    <div class="col"></div>
                </div>

            </div>    
               
        </div> 
       
    </div>  
     
 </div>  


<div class="fondoGris">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" width="100%">
                <p class="fontMS500 text-justify font-22 text-gris" >
                    <br>
                    ¿SERÁ LIBRE EL PERÚ…? ¿DISFRUTARÁN SUS HIJOS DE ESTE INESTIMABLE 
                    DON, POR CUYO GOCE SE HA DERRAMADO TANTA SANGRE? ESTA SI QUE 
                    ES UNA CUESTIÓN DIGNA DE EXAMEN; PORQUE, SI LA INDEPENDENCIA 
                    CONSISTE EN NO PERTENECER A NADIE; LA LIBERTAD NACE DESDE EL 
                    MOMENTO EN QUE UNO PERTENECE A SÍ MISMO ENTRE CUYOS ACTOS 
                    HAY MUCHA DIFERENCIA, SIN EMBARGO DE QUE PARECEN SER UNOS.
                    <br>
                </p>
                <p class="text-right fontMS500Italic font-22 text-gris">
                    <span>
                        EL TRIBUNO DE LA REPÚBLICA PERUANA,<br>
                        NO. XX, 28 DE FEBRERO.
                    </span>
                    <br>
                </p>
                <img src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA_RESALTE.png" class="reflejo"
                    width="100%">
            </div>
        </div>
    </div>
</div>



<div class="fondoAzulO">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-6">
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LIBERTAD DE IMPRENTA <br>
                            EN EL PERÚ INDEPENDIENTE
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-3">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                
                <div class="row mt-5">
                    <div class="col-sm-6">
                       
                            <img width="100%"
                                src="/assets/images/micrositio/micrositio25/PRENSA-012.jpg">
                        
                        <p class="fontMS100Italic font-20" style="color:grey;">
                            <br>
                            José Faustino Sánchez Carrión <br>
                            (Trujillo, 1787 - Lima, 1825)
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="fontMS500 text-white font-24">
                            UNOS MESES DESPUÉS DE LA 
                            PROCLAMACIÓN DE LA 
                            INDEPENDENCIA, JOSÉ DE SAN 
                            MARTÍN DECRETA LA LIBERTAD DE 
                            IMPRENTA EN EL PERÚ CON EL 
                            OBJETIVO DE PROTEGER “EL 
                            DERECHO QUE TIENEN TODOS LOS 
                            HOMBRES A PENSAR, HABLAR Y 
                            ESCRIBIR”.
                            <br><br>
                        </p>
                        <p class="fontMS100 text-white font-24 ">
                            Da pie a la creación de nuevos medios. 
                            Muchos se dedicaban a debatir teoría política 
                            y construir la nueva nación. Otros se 
                            limitaban a la sátira y la injuria. Para poner 
                            freno a la proliferación de medios para fines 
                            personales, San Martín presenta un nuevo 
                            decreto en 1822 en el que precisa que todos 
                            los periódicos deben indicar dónde se 
                            imprimen y quiénes son los dueños de tal 
                            imprenta.
                        </p>
                    </div>
                </div>

                    <div class="row mt-5">
                        
                        <div class="col-sm-3 libro mt-4">
                            <a href="https://hdl.handle.net/20.500.14428/72396" target="_blank" style="color: black;">
                                <img class="img-fluid" width="100%" 
                                    src="/assets/images/micrositio/micrositio25/PRENSA-013.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center text-gris">
                                        <span class="fontMS500">
                                            El Tribuno del Pueblo Peruano.  
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            No. I (28 de noviembre de 1822) al No. III (5 de diciembre de 1822).                                             <br>
                                        </span>
                                        
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-3 libro mt-4">
                            <a href="http://hdl.handle.net/20.500.14428/79647" target="_blank" style="color: black;">
                                <img class="img-fluid" width="100%" 
                                    src="/assets/images/micrositio/micrositio25/PRENSA-014.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            La Abeja Republicana. 
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            Prospecto, No. 1 (4 de agosto de 1822) al
                                            <br>
                                        </span>
                                        No. 36 (5 de  diciembre de 1822). 
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-3 libro mt-4">
                            <a href="http://hdl.handle.net/20.500.14428/79652" target="_blank" style="color: black;">
                                <img class="img-fluid" width="100%" 
                                    src="/assets/images/micrositio/micrositio25/PRENSA-015.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            El Cometa. 
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            No. 1 (17 de agosto de 1822) a
                                            <br>
                                        </span>
                                        No. 4 (21 de setiembre de 1822).
                                    </p>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-3 libro mt-4">
                            <a href="http://hdl.handle.net/20.500.14428/79667" target="_blank" style="color: black;">
                                <img class="img-fluid" width="100%" 
                                    src="/assets/images/micrositio/micrositio25/PRENSA-016.jpg">
                                <div class="overlay">
                                    <p class="fontMS100 text-center">
                                        <span class="fontMS500">
                                            El Imparcial. 
                                            <br>
                                        </span>
                                        <span class="fontMS100Italic">
                                            No. 1 (2 de noviembre de 1822) al No. 5 (30 de noviembre de 1822). 
                                            <br>
                                        </span>
                                        En: Boletín de la Biblioteca Nacional. Año XXIV, no. 53-54 (1970). 
                                    </p>
                                </div>
                            </a>
                        </div>
                        
                    </div>



<!---->

                    <div class="row" style="margin-top: 5%">
                        <div class="col-sm-3">
                            <img class="LineSubsec2 bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                        </div>
                        <div class="c100">
                            <img class="lineCel" width="100%"
                                src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                        </div>
                        <div class="col-sm-6">
                            <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                                class="fontMS700 text-center colorPrincipal font-40">
                                CHARLATANERÍA
                            </p>
                        </div>
                        <div class="c100">
                            <img class="lineCel" width="100%"
                                src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                        </div>
                        <div class="col-sm-3">
                            <img class="LineSubsec2 bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                        </div>
                      
                    </div>

                <div class="row mt-5">
                    <div class="col"></div>
                    <div class="col-sm-3 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79657" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio25/PRENSA-017.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        La Cotorra.  
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        No. 1 (14 de julio de 1822) al                                              <br>
                                    </span>
                                    No. 8 (18 de octubre de 1822).
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79654" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio25/PRENSA-018.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        El Loro. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        No. 1 (30 de agosto de 1822) al
                                        <br>
                                    </span>
                                    No. 6 (4 de octubre de 1822). Facsimilar. 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79648" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio25/PRENSA-019.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        El Periquito.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        No. 1 (6 de noviembre de 1822). 
                                        <br>
                                    </span>
                                    
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col"></div>      
                </div>

        </div>
    </div>
</div>
</div>

<div class="fondoGris_Img2">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            LA PRENSA REALISTA EN RETIRADA
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>
                
                <br><br>
                <div class="row">
                    <div class="col-sm-6">
                        <p class="fontMS500 font-24 mt-5">
                            AL RETIRARSE DE LIMA EN 1821, EL 
                            VIRREY Y EL EJÉRCITO REALISTA SE 
                            LLEVARON LA IMPRENTA DEL ESTADO, 
                            DEBIDO A LA IMPORTANCIA DE LA 
                            PRENSA COMO ARMA IDEOLÓGICA. 
                        </p>
                        <p class="fontMS100 font-24 mt-5">
                            La imprenta se llevaba a lomo de mula, 
                            acompañado por un editor. Los ejércitos de los 
                            dos bandos imprimían decretos, folletos y 
                            boletines desde el campo de batalla.  
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio25/PRENSA-020.jpg">
                        <p class="fontMS500Italic font-22 mb-10" style="color:grey;"><br>
                            El Nuevo Depositario fue un medio satírico 
                            elaborado por los patriotas en el cual se 
                            documentaba la retirada realista, tomando como 
                            blanco al editor realista Gaspar Rico y Angulo</p>
                    </div>
                    
                </div>

                <div class="row mt-5">
                    <div class="col"></div>
                    <div class="col-sm-4 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79651" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio25/PRENSA-021.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        El Depositario. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        La BNP dispone de los siguientes ejemplares: No. 15 (24 de marzo de 1821); No. 19 (3 de abril de 1821) ...
                                        <br>
                                    </span>
                                    
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79655" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio25/PRENSA-022.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        El Nuevo Depositario. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        No. 1 (18 de agosto de 1821) al No. 6 (15 de diciembre de  1821). 
                                        <br>
                                    </span>
                                    En: Boletín de la Biblioteca Nacional, Año XXV, No. 57-58 (1971): pp. 27-78. 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col"></div>
                </div>

                <hr style="margin-top: 5%">

                <div class="row mt-5">
                    <div class="col"></div>
                    <div class="col-sm-4 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/74119" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio25/PRENSA-023.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        Gaceta extraordinaria del Gobierno Legítimo del Perú. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        No. 31 (Cuzco, 28 de enero de 1823), No. 49 (Cuzco, 15 de mayo de 1824),
                                        <br>
                                    </span>
                                    No. 50 (Cuzco, 7 de junio de 1824), No. 53 (Cuzco, 10 de agosto de 1824).
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-4 libro mt-4">
                        <a href="https://hdl.handle.net/20.500.14428/72855" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio25/PRENSA-024.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        El Desengaño. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        No. 1 (Callao, 4 de abril de 1824), No. 12 (Callao, 22 de junio de 1824), No. 17 (3 de agosto de 1824), No. 23 (6 de octubre de 1824), No. 26 (31 de octubre de 1824), 
                                        <br>
                                    </span>
                                    No. 28 (17 de noviembre de 1824) al No. 34 (30 de diciembre de 1824); No. 1 (12 de enero de 1825). 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col"></div>
                </div>


                <div class="row mt-5">
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-8">
                        <p style="line-height: 100%;margin-bottom: 0%;padding-bottom: 0%;"
                            class="fontMS700 text-center colorPrincipal font-40">
                            PRECURSORES DE LA PRENSA INDEPENDIENTE
                        </p>
                    </div>
                    <div class="c100">
                        <img class="lineCel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                    <div class="col-sm-2">
                        <img class="LineSubsec2 bottom_cel" width="100%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada.png">
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS100 text-justify font-24 mt-5">
                            En 1823 se estableció la Imprenta Municipal de Trujillo
                            como la primera imprenta en el norte del Perú. El primer periódico
                            de Trujillo se publicó un día después de la batalla de Ayacucho,
                            y se limitó a difundir decretos y discursos de Simón Bolívar.
                            Del mismo modo, la Imprenta Municipal de Arequipa se estableció en julio de 1824,
                            dando pie a una serie de periódicos oficialistas respaldados por Simón Bolívar.
                            Aunque los primeros periódicos son oficialistas, en las décadas posteriores,
                            las tres ciudades promoverán la prensa republicana 
                        </p>
                        
                    
                    </div>
                </div>


                <div class="row mt-5">
                    <div class="col"></div>
                    <div class="col-sm-3 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79649" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio25/PRENSA-025.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        El Patriota de Trujillo. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        No. 2 (Trujillo, 30 de diciembre de 1824)
                                        <br>
                                    </span>
                                    
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro mt-4">
                        <a href="https://hdl.handle.net/20.500.14428/73731" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio25/PRENSA-026.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        La Estrella de Ayacucho.
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Prospecto, No. 1 (Arequipa, 12 de  marzo de 1825) al 
                                        <br>
                                    </span>
                                    No. 5 (Arequipa, 9 de abril de 1825). 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col-sm-3 libro mt-4">
                        <a href="http://hdl.handle.net/20.500.14428/79650" target="_blank" style="color: black;">
                            <img class="img-fluid" width="100%" 
                                src="/assets/images/micrositio/micrositio25/PRENSA-027.jpg">
                            <div class="overlay">
                                <p class="fontMS100 text-center">
                                    <span class="fontMS500">
                                        El Republicano. 
                                        <br>
                                    </span>
                                    <span class="fontMS100Italic">
                                        Prospecto, No. 1 (Arequipa, 26 de noviembre de 1825) al 
                                        <br>
                                    </span>
                                    No. 6 (Arequipa, 31 de diciembre de 1825). 
                                </p>
                            </div>
                        </a>
                    </div>
                    <div class="col"></div>
                </div>


            </div>
        </div>
    </div>
</div>



<div class="fondoCeleste">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div style="margin-bottom: 5%;" class="row">
                    <div class="col-sm-4">
                        <p style="line-height: 130%;margin-bottom: 0%;" class="fontMS500 text-white font-70">
                            Espacio <br> de diálogo
                        </p>
                    </div>
                    <div class="col-sm-8">
                        <img id="img_dialogo"
                            src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO1.png">
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <p class="fontMS500 text-justify text-white font-28 ">
                            <br>
                            De acuerdo a la prensa patriota de la independencia del Perú, y al nacimiento de la incipiente nación.
                            <br><br>
                        </p>
                    </div>
                    <div class="row mt-4">
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿A quiénes se dirigen los 
                                autores? ¿Quiénes leían los 
                                periódicos en esa época? 
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                ¿Qué aporta la prensa al 
                                conocimiento de la historia 
                                de la Independencia? ¿Cómo 
                                se compara con otras fuentes 
                                históricas? 
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                        <div class="col-sm-4">
                            <p class="fontMS500  text-white font-28">
                                En la era digital, ¿cuál es el rol de la prensa
                                 - o de los medios de comunicación
                                  - en los conflictos internacionales?
                                <br><br>
                                <img class="c100 mt-3" width="100%"
                                    src="\assets\images\micrositio\micrositio1\ET01_MS01_FEDE_LINEA_DIALOGO2.png">
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                    <div class="col-sm-4">
                        <img class="bottom_cel" width="100%"
                                src="/assets/images/micrositio/micrositio3/ET02_MS03_FOT_LINEA_DIALOGO2.png">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="fondoBlanco">
    <div class="container">
        <div class="row marg">
            <div class="col-sm-12">
                <div class="row">
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%" style="margin-bottom:20%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada2.png">
                        <img class="LineSubsec c100" width="100%" style="margin-bottom:0%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada2.png">
                    </div>
                    <div class="col-sm-4 text-center">
                        <p style="line-height: 200%;margin-top: 10%;"
                            class="fontMS700 text-center font-40 colorPrincipal bottom_cel">
                            PARA SABER MÁS
                        </p>
                        <p style="line-height: 160%;margin-bottom: 0%;"
                            class="fontMS700 text-center font-40 colorPrincipal c100">
                            PARA SABER MÁS
                        </p>
                    </div>
                    <div class="col-sm-4">
                        <img class="LineSubsec bottom_cel" width="100%" style="margin-bottom:20%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada2.png">
                        <img class="LineSubsec c100" width="100%" style="margin-bottom:0%"
                            src="/assets/images/micrositio/micrositio2/ET02_MS01_COMPOSIT_LINEA1-recortada2.png">
                    </div>
                </div>
                <p class="fontMS100 font-24">
                    <br>
                    Recomendamos algunas de las fuentes consultadas durante la investigación.
                    <br>
                </p>
                <div class="row ">
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Basadre, J. (1954).
                            </span><br>
                            <span class="fontMS100 text-gris">
                                Historia de la idea de “patria” en la
                                emancipación del Perú. En: Mercurio
                                Peruano, año XXIX, vol. XXXV, no. 330, p. 
                                645-683<br></span>
                            <!--  
                            <span class="text-gris">
                                
                            </span>
                            <a href="" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>--> 
                        </p>
                        <p class="font-24 ">
                            <br>
                            <span class="fontMS500">
                                Cornejo Quesada, C. (2007).
                            </span><br>
                            <span class="fontMS100 text-gris">
                                El laberinto y primavera del periodismo 
                                peruano independentista. En: Cultura, vol. 21, 
                                no. 21, p. [229]-277. 
                                <br></span>
                            <span class="text-gris" style="word-wrap: break-word;">
                                https://www.revistacultura.com.pe/revistas/RCU_21_1_el-laberinto-y-primavera-del-periodismo-peruano-independentista.pdf
                            </span><br>
                            <a href="https://www.revistacultura.com.pe/revistas/RCU_21_1_el-laberinto-y-primavera-del-periodismo-peruano-independentista.pdf" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Dunbar Temple, E. (1936).
                            </span><br>
                            <span class="fontMS100 text-gris">
                                El Investigador. Un periódico de los años 
                                1813-1814. Lima: Instituto Sanmartiniano del 
                                Perú.  
                            </span>
                            <!--
                            <span class="text-gris">
                                
                            </span><br>
                            <a href="" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                       -->
                        </p>
                    </div>
                    <div class="col-sm-6">
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Macera, P. (1977).
                            </span><br>
                            <span class="fontMS100 text-gris">
                                El periodismo en la independencia. En: 
                                Trabajos de historia. Lima: Instituto Nacional 
                                de Cultura, p. 325-342. 
                            </span>
                            <!--
                            <span class="text-gris">
                               
                            </span><br>
                            <a href="" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                        -->
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Martínez Riaza, A. (1985).
                            </span><br>
                            <span class="fontMS100 text-gris">
                                La prensa doctrinal en la independencia del 
                                Perú, 1811-1824. Madrid: Eds. Cultura 
                                Hispánica, Instituto de Cooperación 
                                Iberoamericana.
                            </span>
                            <!--
                            <span class="text-gris">

                            </span><br>
                            <a href="" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                           -->
                        </p>
                        <p class="font-24">
                            <br>
                            <span class="fontMS500">
                                Varillas, A. (2008).
                            </span><br>
                            <span class="fontMS100 text-gris">
                                El periodismo en la historia del Perú: desde 
                                sus orígenes hasta 1850. Lima: Universidad 
                                de San Martín de Porres, Escuela de Ciencias 
                                de la Comunicación, Instituto de 
                                Investigaciones.
                            </span>
                           <!--
                            <span class="text-gris">

                            </span><br>
                            <a href="" target="_blank"
                                style="color: black;">
                                <span class="fas fa-share-square text-gris"></span>
                            </a>
                            -->
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Footer -->
